export default {
  title: "Supplier Relationship Management System",
  systemSetting: "System Settings",
  logout: "Logout",
};
